export default __webpack_public_path__ + "static/media/logo_gorgias.7125e910.svg";